'use strict';

import "core-js/modules/es6.array.is-array";

function isEmpty(obj) {
  if (Array.isArray(obj)) {
    return obj.length === 0;
  } else if (typeof obj === 'object') {
    for (var i in obj) {
      return false;
    }

    return true;
  } else {
    return !obj;
  }
}

export default isEmpty;